import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';
export const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end', // Align modal at the bottom
    alignItems: 'center',
    backgroundColor: themes.light.modalBackground[1],
    width: '100%',
  },
  modalContainer: {
    width: '100%', // Full width for bottom modal
    backgroundColor: themes.light.white[1],
    borderTopLeftRadius: 20, // Rounded corners at the top
    borderTopRightRadius: 20,
    padding: 16,
    maxHeight: '90%',
  },
  header: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'SF Pro Display',
    fontWeight: 'bold',
    fontSize: 20,
    color: themes.light.gray_blue[1],
  },
  closeIcon: {
    width: 24, // Set image width to 24px
    height: 24, // Set image height to 24px
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeImage: {
    width: 20, // Set image width to 24px
    height: 20, // Set image height to 24px
    resizeMode: 'contain', // Ensure the image scales well
  },
});
